import React, { useEffect, useState } from 'react';
import { localePath } from '../config/region';
import { useParams, Navigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import ParticleBackground from './ParticleBackground';
import SeoHead from './SeoHead';
import { apiGet } from '../utils/apiUtils';
import { API_URLS } from '../config/api';
import { t } from '../i18n';
import './NewsPostPage.css';

const NewsPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    apiGet(API_URLS.NEWS_POST(slug))
      .then(res => { setPost(res.data); setLoading(false); })
      .catch(() => { setNotFound(true); setLoading(false); });
  }, [slug]);

  if (notFound) return <Navigate to="/news" replace />;

  if (loading) {
    return (
      <div className="npp-wrap">
        <ParticleBackground />
        <div className="npp-app"><div className="npp-loading">{t('Загрузка...')}</div></div>
      </div>
    );
  }

  return (
    <div className="npp-wrap">
      <SeoHead
        title={post.title}
        description={post.title}
        path={`/news/${post.slug}`}
        type="article"
      />
      <ParticleBackground />
      <div className="npp-app">
        <div className="npp-header">
          <a href={localePath('/news')} className="npp-back">
            <ChevronLeft size={14} /> {t('Новости')}
          </a>
          <h1 className="npp-title">{post.title}</h1>
          <span className="npp-date">
            {new Date(post.created_at).toLocaleDateString('ru-RU', {
              day: 'numeric', month: 'long', year: 'numeric'
            })}
          </span>
        </div>
        <div
          className="npp-body"
          dangerouslySetInnerHTML={{ __html: post.html_content }}
        />
      </div>
    </div>
  );
};

export default NewsPostPage;
